export default __webpack_public_path__ + "locales/uk-UA/PreparationPortal.json?hash=9150ac6b66c2a10ac8ddac56e5cf5e25";